<template>
  <div class="lista-categorias">
    <!-- Buscador -->
    <div class="lista-categorias__search-wrapper">
      <input
        v-model="searchTerm"
        type="text"
        class="lista-categorias__search"
        placeholder="Buscar categoría…"
      />
    </div>

    <!-- Lista -->
    <div v-if="filteredCategorias.length" class="lista-categorias__scroll">
      <div
        v-for="categoria in filteredCategorias"
        :key="categoria.id_categoria"
        class="lista-categorias__item"
      >
        <span class="lista-categorias__dot"></span>
        <p class="lista-categorias__name">
          {{ categoria.nombre }}
        </p>
      </div>
    </div>

    <!-- Sin resultados por filtro -->
    <p
      v-else-if="categorias && categorias.length"
      class="lista-categorias__empty"
    >
      No hay categorías que coincidan con la búsqueda.
    </p>

    <!-- Sin categorías en general -->
    <p
      v-else
      class="lista-categorias__empty"
    >
      No hay categorías registradas aún.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ListaCategorias',
  props: {
    categorias: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  computed: {
    filteredCategorias() {
      if (!this.categorias || this.categorias.length === 0) return [];

      const term = this.searchTerm.trim().toLowerCase();
      if (!term) return this.categorias;

      return this.categorias.filter((cat) =>
        String(cat.nombre || '')
          .toLowerCase()
          .includes(term)
      );
    },
  },
};
</script>

<style scoped lang="scss">
.lista-categorias {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

/* Buscador */
.lista-categorias__search-wrapper {
  width: 100%;
}

.lista-categorias__search {
  width: 100%;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background: rgba(15, 23, 42, 0.9);
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  color: #e5e7eb;
  outline: none;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.9);
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    background 0.16s ease;
}

.lista-categorias__search::placeholder {
  color: #6b7280;
}

.lista-categorias__search:focus {
  border-color: rgba(129, 140, 248, 0.95);
  background: rgba(15, 23, 42, 0.98);
  box-shadow:
    0 0 0 1px rgba(129, 140, 248, 0.7),
    0 0 0 1px rgba(15, 23, 42, 1);
}

/* Contenedor scrollable: ~6 ítems visibles */
.lista-categorias__scroll {
  margin-top: 0.2rem;
  max-height: 210px; /* aprox. 6 elementos */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.7) transparent;
}

/* WebKit scrollbars */
.lista-categorias__scroll::-webkit-scrollbar {
  width: 4px;
}

.lista-categorias__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.lista-categorias__scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(
    180deg,
    rgba(148, 163, 184, 0.9),
    rgba(129, 140, 248, 0.9)
  );
  border-radius: 999px;
}

/* Cada categoría como “pill row” */
.lista-categorias__item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.55);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.85);
}

/* Puntito decorativo */
.lista-categorias__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: radial-gradient(circle, #38bdf8, #1d4ed8);
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.9);
  flex-shrink: 0;
}

/* Nombre de la categoría */
.lista-categorias__name {
  font-size: 0.8rem;
  color: #e5e7eb;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* Estados vacíos / sin match */
.lista-categorias__empty {
  font-size: 0.8rem;
  color: #9ca3af;
  font-style: italic;
}
</style>
